function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      ".summary-child, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

// Optional: handling keyup escape event if needed
$('[id^="Details-"] .summary-child').on("keyup", function (event) {
  if (event.key === "Escape") {
    onKeyUpEscape(event); // Ensure this function is defined
  }
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest(
    ".accordion-main-details[open]"
  );
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector(".summary-child");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
    var qtyWarningInput = document.querySelector(
      ".product-add-to-cart-error .error"
    );
    if (this.input.max == 0 && this.input.dataset.limit > 0) {
      var qty_limit = theme.qty_limit_msg;
      var productTitle = this.input.dataset.productTitle;
      qty_limit = qty_limit.replaceAll("XX", this.input.max).replaceAll("YY", productTitle);
      if (qtyWarningInput) {
        qtyWarningInput.innerHTML = qty_limit;
      }
    } else {
      if (qtyWarningInput) {
        qtyWarningInput.innerHTML = "";
      }
    }
  }
}
customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll(".summary-child").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      "button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)"
    ).forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest(
      ".accordion-main-details[open]"
    );
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector(".summary-child")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    // console.log("summaryElement", summaryElement);
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle
      .querySelectorAll(".accordion-main-details")
      .forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest(
      ".accordion-main-details"
    );
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector(".summary-child"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest(".accordion-main-details[open]")) {
          trapFocus(
            detailsElement.closest(".accordion-main-details[open]"),
            detailsElement.querySelector(".summary-child")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector(".announcement-bar-slider");
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      );
      this.reducedMotion.addEventListener("change", () => {
        if (this.slider.getAttribute("data-autoplay") === "true")
          this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          "click",
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this)
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = "next") {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === "next" ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = "announcement-bar-slider--fade-in";
    const animationClassOut = "announcement-bar-slider--fade-out";

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext =
      (button === "next" && !isLastSlide) ||
      (button === "previous" && isFirstSlide);
    const direction = shouldMoveNext ? "next" : "previous";

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  connectedCallback() {
    // Run updateVariantStatuses when the element is added to the DOM
    this.updateVariantStatuses();

    //once on Page load event
    /*Custom option handle starts*/
    // console.log("once on page load evt");
    var pd = this.getProductData();
    $(`.variant-input[data-value]`).removeClass("custom-disabled");
    var $atcBtn = $(
      `.pdp_main .product__info-container .product-form__buttons .button:eq(0)`
    );
    // $atcBtn.show();
    // $atcBtn.find("span:not(.custom-js-price)").text("Add to cart");
    $atcBtn.find('span.atc-text-custom').addClass('hide');
    $atcBtn.find('span.atc-text').removeClass('hide');
    $atcBtn.removeClass("disabled").removeAttr("disabled");
    this.linkCustomOption(pd, this.dataset.section, true);
    /*Custom option handle ends*/

    // NEW: enable cross-size flavor switching (additive, non-breaking)
    if (!this._crossSizeSwitchBound) {
      this._crossSizeSwitchBound = true;
      this.addEventListener("click", this.onCrossSizeFlavorClick.bind(this), true);
    }
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    var $atcBtn = $(
      `.pdp_main .product__info-container .product-form__buttons .button:eq(0)`
    );
    $atcBtn.find('span.atc-text-custom').addClass('hide');
    $atcBtn.find('span.atc-text').removeClass('hide');
    if (this.currentVariant) {
      let $this = this;

      var id = this.currentVariant.id.toString();
      var currentVariantData = window.currentColor.filter( (item) => item.id == id );

      /*Custom option handle starts*/
      var pd = this.getProductData();
      $(`.variant-input[data-value]`).removeClass("custom-disabled");
      var $atcBtn = $( `.pdp_main .product__info-container .product-form__buttons .button:eq(0)` );
      // $atcBtn.find("span:not(.custom-js-price)").text("Add to cart");
      $atcBtn.find('span.atc-text-custom').addClass('hide');
      $atcBtn.find('span.atc-text').removeClass('hide');
      $atcBtn.removeClass("disabled").removeAttr("disabled");
      this.linkCustomOption(pd, this.dataset.section);
      /*Custom option handle end*/

      // variantChangeHide($this,this.currentVariant)


      var varInputVal = '';
      if(currentVariantData[0].size_bubble){
        varInputVal = `${event.target.value} - ${currentVariantData[0].size_bubble}`;
      }else{
        varInputVal = `${event.target.value}`;
      }
      if (varInputVal) {
        $(event.target) .parents(".variant-wrapper") .find(".variant__label-info") .text(varInputVal);
      }

      if ($(`div#loop-product-variant-${id}`)) {
        $(`div#loop-product-variant-${id} input.loop-subscription-group-radio` ).trigger("click");
      }    

      if (currentVariantData[0].background_color == "") {
        currentVariantData[0].background_color = "#FAF7EE";
      }
      // ****** Background Animation JS START ******
      var animationTimeout;
      var animationInProgress = false;

      const overlay = document.getElementById('transitionOverlay');
      const svg = document.getElementById('transitionWave');

      // Function to detect if it's mobile
      function isMobile() {
        return window.innerWidth <= 768;
      }

      let atcBtn = document.querySelector('button.product-form__submit[data-product-id]');

      if (atcBtn) {
        // Find the product form
        let productForm = atcBtn.closest('form');

        if (currentVariantData[0].preorder) {
          atcBtn.setAttribute("data-button-text", "Pre-order");

          // Add hidden input if it doesn't exist
          if (productForm && !productForm.querySelector('.input_preorder')) {
            let input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'properties[preorder]';
            input.value = 'true';
            input.className = 'input_preorder';

            productForm.appendChild(input);
          }

        } else {
          // Remove button text
          atcBtn.removeAttribute("data-button-text");

          // Remove hidden input
          let preorderInput = productForm?.querySelector('.input_preorder');
          if (preorderInput) {
            preorderInput.remove();
          }
        }
      }

      function animateOverlay() {
        if (!animationInProgress) {
          if(overlay){
            clearTimeout(animationTimeout);
            const waitTime = isMobile() ? 300 : 500;
            const animationDuration = isMobile() ? 700 : 1000;
            const colorChangeDelay = isMobile() ? 350 : 500;

            animationTimeout = setTimeout(() => {
              $("body.template-product").css("--product_background_color", currentVariantData[0].background_color);
              $("body.template-product").css("background", currentVariantData[0].background_color);

              animationInProgress = true;

              overlay.classList.add('animate-slide');

              // Update the background and SVG color after a reduced delay for mobile
              setTimeout(() => {
                requestAnimationFrame(() => {
                  overlay.style.background = currentVariantData[0].background_color;
                  svg.setAttribute('fill', currentVariantData[0].background_color);
                });
              }, colorChangeDelay);

              // Remove the slide class and reset styles after the animation completes
              setTimeout(() => {
                overlay.classList.remove('animate-slide');
                overlay.style.background = currentVariantData[0].background_color;
                svg.setAttribute('fill', currentVariantData[0].background_color);
                overlay.style.transform = 'translate3d(0, 0, 0)';
                animationInProgress = false;
              }, animationDuration);
            }, waitTime);
          }
        }
      }

      if (!animationInProgress) {
        animateOverlay();
      }
      // ****** Background Animation JS END ******

      var variant = this.currentVariant;
      // Find the matching variant frames
      const Customevent = new CustomEvent("myCustomEvent", {
        detail: variant,
      });
      // To trigger the Event
      document.dispatchEvent(Customevent);

      this.updateSelectedSwatchValue(event);

      this.toggleAddButton(true, "", false);
      // this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantStatuses();

      setTimeout(() => {
        customOption();
      }, 500);

      /*Custom data change on variant */
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      const AtcButton = productForm.querySelector(".product-form__submit");
      const sticky_atc = document.querySelector('.js-sticky-atc');
      const kalviyoBtn = document.querySelectorAll(".custom-klaviyo-button");
      const Subscription = document.querySelector('.pdp-subscription-wrapper');
      if (this.currentVariant.available) {
        AtcButton.style.display = "block";
        sticky_atc.style.display = "block";
        kalviyoBtn.forEach(button => {
          button.style.display = "none";
          button.classList.remove('animate-zoom-in')
        });
        if(Subscription){
          Subscription.classList.remove('variant-oos')
        }
        AtcButton.removeAttribute("disabled");
        $('body').removeClass('variant-oos-wrapper');
      } else {
        AtcButton.style.display = "none";
        sticky_atc.style.display = "none";
        kalviyoBtn.forEach(button => {
          button.style.display = "block";
          button.classList.add('animate-zoom-in');
        });
        $('body').addClass('variant-oos-wrapper');
        if(Subscription){
          Subscription.classList.add('variant-oos')
        }
      }

      // Floating Image change
      if(currentVariantData[0].primary_floating_image == ''){
        $('.primary_floating_image').addClass('hide');
      }else{
        $('.primary_floating_image').removeClass('hide');
        $('.primary_floating_image img').attr('src',currentVariantData[0].primary_floating_image);
      }
      if(currentVariantData[0].secondary_image_1 == ''){
        $('.pdp_fruit.fruit1').addClass('hide')
      }else{
        $('.pdp_fruit.fruit1').removeClass('hide')
        $('.pdp_fruit.fruit1 img').attr('src',currentVariantData[0].secondary_image_1);
      }
      if(currentVariantData[0].secondary_image_2 == ''){
         $('.pdp_fruit.fruit2').addClass('hide')
      }else{
        $('.pdp_fruit.fruit2').removeClass('hide')
        $('.pdp_fruit.fruit2 img').attr('src',currentVariantData[0].secondary_image_2);
      }
      if(currentVariantData[0].secondary_image_3 == ''){
        $('.pdp_fruit.fruit3').addClass('hide')
      }else{
        $('.pdp_fruit.fruit3').removeClass('hide')
        $('.pdp_fruit.fruit3 img').attr('src',currentVariantData[0].secondary_image_3);
      }
      if(currentVariantData[0].secondary_image_4 == ''){
        $('.pdp_fruit.fruit4').addClass('hide')
      }else{
        $('.pdp_fruit.fruit4').removeClass('hide')
        $('.pdp_fruit.fruit4 img').attr('src',currentVariantData[0].secondary_image_4);
      }
      if(currentVariantData[0].collab_image != ''){
        $('.pdp-collab-img img').removeClass('hide').attr('src',currentVariantData[0].collab_image);
      }else{
         $('.pdp-collab-img img').addClass('hide')
      }
      $('.popup-img img').attr('src',currentVariantData[0].popupImg)

      var productUSP = $('.variant_data.product-usp').find(`.usp-var-data.usp-var-${id} .pdp-animated-icon`).clone()
      if(window.innerWidth > 768){
        $('body.template-product .main-product-section > .pdp-usp-icon').empty().append(productUSP)
      }else{
        $('body.template-product .pdp_main .mobile-content-full .pdp-usp-icon').empty().append(productUSP)
      }

      const allTooltip = document.querySelectorAll("[data-tooltip]");

      allTooltip.forEach((tooltip) => {
        var content = tooltip.getAttribute("data-tooltip");
        // console.log('content',content)
        tippy(tooltip, {
          content: content,
          allowHTML: true,
          arrow: true,
          theme: 'light'
        });
      });

      // Floating Image chnage end

      var clonedElementpdpIcon = $(".variant_data .pdp_html_" + id).clone(); // Clone the element
      var clonedCollapsible = $( ".collapsible_content .collapisble_" + id ).clone();
      var falvorClone = $(".flavor .falvor_" + id).clone();
      var animate_icon = $(".animated .animated_" + id).clone();
      var faq_clone = $('.faq_'+id).clone();
      if($('.faq_accordions .accordion_bg')){
        $('.faq_accordions .accordion_bg').empty().append(faq_clone)
      }
      $('.custom-animated-icon-text .animate_wrapper').empty().append(animate_icon)
      $(".collapsible-content .section_wrapper")
        .empty()
        .append(clonedCollapsible);
      $(".pdp-descripton-icons .section_wrapper")
        .empty()
        .append(clonedElementpdpIcon); // Append the cloned element
      $(".product-flavor-tabs .flavour_tabs_main").removeClass('hide').empty().append(falvorClone);
      $(".product__title2 h2").empty().text(currentVariantData[0].second_title);

      if (window.theme.is_rtd_template) {
        if($('.extra-div')){
          var benefit_heading_color = currentVariantData[0].benefit_heading_color, benefit_content_color = currentVariantData[0].benefit_content_color;
          $('.extra-div').css({'--benefit_heading_color': benefit_heading_color, '--benefit_content_color': benefit_content_color});
        }
        // Open & Close BOX Image Change JS on variant change
        if(currentVariantData[0].open_box_img || currentVariantData[0].close_box_img){
          window.theme.rtd_open_box_image = currentVariantData[0].open_box_img; window.theme.rtd_close_box_image = currentVariantData[0].close_box_img;
          $('.close-box-img').parent().removeClass('hide'); $('.close-box-img').attr('src',window.theme.rtd_open_box_image)
        }else{
          $('.close-box-img').removeAttr('src'); $('.close-box-img').parent().addClass('hide');
        }

        var rtd_flavor_images = $(`.rtd-flavor-images-one .rtd_flavor_images_${id} .rtd_flavor_images_main`).clone();
        $('body.product-rtd-pdp .product__media-wrapper .rtd-flavor-images').empty().append(rtd_flavor_images)

        if($('.variant_data.benefits_one') || $('.variant_data.benefits_two') || $('.variant_data.benefits_mobile')){
          if(window.innerWidth > 768){
            var variant_benefites = currentVariantData[0].variant_benefites;

            // if(!variant_benefites) return
            if(variant_benefites){
              variant_benefites.forEach((benefit, index) => {
                console.log("benefit::", index, benefit, $(`.benefits-items.wrapper-index-${index + 1}`));
                var element = $(`.benefits-items.wrapper-index-${index + 1}`); // Adjusted to match the index in the HTML
            
                if (element.length) {
                  element.find('.banefit-title').html(benefit.heading); // Set the benefit title
                  element.find('.banefit-content').html(benefit.content); // Set the benefit content
          
                  const flavorsImages = element.find('.flavors-images');
                  if (flavorsImages.length && benefit.images.length) {
                    const imageMapping = [{ className: '.text-content-fruit1 img', imageIndex: 0 },{ className: '.text-content-fruit2 img', imageIndex: 1 },{ className: '.text-content-fruit3 img', imageIndex: 2 }];
        
                    imageMapping.forEach(imageMap => {
                      const imgElement = flavorsImages.find(imageMap.className), imgData = benefit.images[imageMap.imageIndex];    
                      if (imgElement.length && imgData) {imgElement.attr('src', imgData.src || '');imgElement.attr('alt', imgData.alt || '');}
                    });
                  }
                }
              });
            }
          }else{
            var BenefitContentMobile = $(`.benefits_mobile .benefits_mobile_${id} .benefits-main.benefits_mobile--${id}`).clone();
            $('body.product-rtd-pdp .product__info-wrapper > .mobile-benefit > .main-content.mobile-content').empty().append(BenefitContentMobile);
            $('body.product-rtd-pdp .product__info-wrapper > .mobile-benefit > .main-content.mobile-content .benefits-items').removeClass('data');

            // setTimeout(()=> {
            // console.log("ELE",$('body.product-rtd-pdp .product__info-wrapper > .mobile-benefit > .main-content.mobile-content .benefits-main').get(0))
            // $('body.product-rtd-pdp .product__info-wrapper > .mobile-benefit > .main-content.mobile-content .benefits-main').slick('unslick');
              $('body.product-rtd-pdp .product__info-wrapper > .mobile-benefit > .main-content.mobile-content .benefits-main').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                adaptiveHeight: true
              });
          }
        }
      }

      if(window.innerWidth < 768){
        var product_feature_thumbnail = $(`.product-feature-thumbnail .product_feature_thumbnail_${id} .product-feature-thumbnail .product-feature-thumbnail-wrapper`).clone();

        console.log("product_feature_thumbnail::",product_feature_thumbnail)
        if(product_feature_thumbnail){
          $('.pro_ani_img .product-feature-thumbnail').css({
            "--product_primary_color": currentVariantData[0].primary_color,
            "--product_primary_text_color": currentVariantData[0].primary_text_color,
          })
          $('.pro_ani_img .product-feature-thumbnail').empty().append(product_feature_thumbnail);
        }
      }

      this.initializeTooltips();
      // var background_color = $('.main-product-section').data('bg-color');
      // console.log('colors', currentVariantData)
      $(".pdp_main span.product-badge.size-opt, document.documentElement").css({
        "--product_primary_color": currentVariantData[0].primary_color,
        "--product_primary_text_color": currentVariantData[0].primary_text_color,
      });
      if($('.pdp_main .product__product_badge .product-badge.size-opt') && this.currentVariant){
        if(currentVariantData[0].size_bubble){
          // console.log("size_bubble::",currentVariantData[0].size_bubble)
          $('.pdp_main .product__product_badge .product-badge.size-opt').text(currentVariantData[0].size_bubble)
        }else{
          $('.pdp_main .product__product_badge .product-badge.size-opt').text(this.currentVariant.option1)
        }
      }
      $(".pdp_main .product__title2 h2, .var_option_2 .variant__label .variant__label-info, .sticky-bar .product-left-content .ptitle2 h2").css({"--product_primary_color": currentVariantData[0].primary_color});
      $('product-info.product__info-container').css({"--product_primary_color": currentVariantData[0].primary_color});
      $(" .pdp_main .product__product_badge .product-badge").css({
        "--product_secondary_color": currentVariantData[0].secondary_color,
        "--product_secondary_text_color": currentVariantData[0].secondary_text_color,
      });
      // console.log('currentVariantData',currentVariantData)
      $('.accordions .banner-bg').css({'--bg_color':currentVariantData[0].faq_bg_color});
      $('.accordions .accordion_bg').css({'--faq_text_color':currentVariantData[0].faq_text_color})
      $('.product-flavor-tabs .banner-bg').css({'--banner-bg':currentVariantData[0].flavor_bg_color})
      $('.product-flavor-tabs .flavour_tabs_main').css({
        '--flavor_tab_text_color':currentVariantData[0].flavor_tab_text_color,
        '--hover_bg_color':currentVariantData[0].flavor_text_hover_bg_color,
        '--flavor_text_hover_color':currentVariantData[0].flavor_text_hover_color
      })

      /*Custom data change on variant ends */

      if (!this.currentVariant) {
        this.toggleAddButton(true, "", true);
        this.setUnavailable();
      } else {
        var variantLabel = document.querySelector( ".option-size-2 .variant__label-info" );
        if (variantLabel && this.currentVariant) {
          variantLabel.textContent = this.currentVariant.option2;
        }
        var customPriceinBtn = document.querySelector(".custom-js-price");
        if (customPriceinBtn && this.currentVariant) {
          // console.log("this.currentVariant::",customPriceinBtn.parents('button').find('.js-custom-price-copy'))
          customPriceinBtn.textContent = ` - ${Shopify.formatMoney(this.currentVariant.price,Shopify.money_format)}`;
        }

        var stockMeter = document.querySelector(
          "li.icon-with-text__item.stock_meter-true"
        );
        if (stockMeter) {
          if (this.currentVariant.available) {
            stockMeter.classList.add("in-stock");
            stockMeter.classList.remove("out-stock");
            stockMeter.querySelector( ".inline-richtext" ).innerHTML = ` In Stock`;
          } else {
            stockMeter.classList.remove("in-stock");
            stockMeter.classList.add("out-stock");
            stockMeter.querySelector( ".inline-richtext" ).innerHTML = ` Out of Stock`;
          }
        }
        // console.log('this.currentVariant ',this.currentVariant)
        if (this.currentVariant.available) {
          var prod_price = this.currentVariant.price;
          if (this.currentVariant.compare_at_price) {
            prod_price = this.currentVariant.price;
          }
          var emi = 4;
          var emp_price = prod_price / emi;
          var fomatted_price = Shopify.formatMoney(
            emp_price,
            Shopify.money_format
          );
          $(".js-afterpay-wrapper").show();
          $(".emp_price").html(fomatted_price);
        } else {
          $(".js-afterpay-wrapper").hide();
          $(".emp_price").empty();
        }

        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateShareUrl();
      }
    } else {
      var varInputVal = event.target.value;
      if (varInputVal) {
        $(event.target)
          .parents(".variant-wrapper")
          .find(".variant__label-info")
          .text(varInputVal);
      }

      this.toggleAddButton(true, "", true);
      this.setUnavailable();

      if (window.theme.is_rtd_template) {
        if ($(".close-box-img")) {
          $(".close-box-img").removeAttr("src");
          $(".close-box-img").parent().addClass("hide");
        }
      }
     
    }

  }

  linkCustomOption(product, parent,onLoad) {
    // console.log('product',product)
    // Building our mapping object.
    Shopify.optionsMap = {};
    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];
      if (variant.available) {
        // Gathering values for the 1st drop-down.
        Shopify.optionsMap["root"] = Shopify.optionsMap["root"] || [];
        Shopify.optionsMap["root"].push(variant.option1);
        Shopify.optionsMap["root"] = Shopify.uniq(Shopify.optionsMap["root"]);
        // Gathering values for the 2nd drop-down.
        if (product.options.length > 1) {
          var key = variant.option1;
          Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
          Shopify.optionsMap[key].push(variant.option2);
          Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
        }
        // Gathering values for the 3rd drop-down.
        if (product.options.length === 3) {
          var key = variant.option1 + " / " + variant.option2;
          Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
          Shopify.optionsMap[key].push(variant.option3);
          Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
        }
      }
    }

    // // Update options right away.
    this.updateOptionsInSelector(0, parent,onLoad);
    if (product.options.length > 1) this.updateOptionsInSelector(1, parent,onLoad);
    if (product.options.length === 3) this.updateOptionsInSelector(2, parent,onLoad);

    // // When there is an update in the first dropdown.
    // $(parent + " .single-option-selector:eq(0)").change(function() {
    //   Shopify.updateOptionsInSelector(1, parent);
    //   if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
    //   return true;
    // });
    // // When there is an update in the second dropdown.
    // $(parent + " .single-option-selector:eq(1)").change(function() {
    //   if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
    //   return true;
    // });
  }

  updateOptionsInSelector(selectorIndex, parent, onLoad = false) {
    // console.log('parent',parent)
    switch (selectorIndex) {
      case 0:
        var key = "root";
        var selector = $(`[data-section="${parent}"] .option-size-1`);
        break;
      case 1:
        var key = $(
          `[data-section="${parent}"] .option-size-1 input:checked`
        ).val();
        var selector = $(`[data-section="${parent}"] .option-size-2 input:checked`);
        break;
      case 2:
        var key = $(
          `[data-section="${parent}"] .option-size-1 input:checked`
        ).val();
        key +=
          " / " +
          $(`[data-section="${parent}"] .option-size-2 input:checked`).val();
        var selector = $(`[data-section="${parent}"] .option-size-3 input:checked`);
    }

    var initialValue = selector.val();
    // 	selector.empty();
    // console.log('initialValue',initialValue)
    var hiddenVars = productVariantData.filter((v) => {
      return v[`option${selectorIndex}`] == key && v.meta_hide == true;
    });
    var hiddenSingleVar = productVariantData.filter((v) => {
      return initialValue != null && v[`option${selectorIndex}`] == key && v.meta_hide == true && v.option2==initialValue;
    });
    if (onLoad) {
      // Step 1: Group items by option1
      const groupedByOption1 = productVariantData.reduce((groups, item) => {
        if (!groups[item.option1]) {
          groups[item.option1] = [];
        }
        groups[item.option1].push(item);
        return groups;
      }, {});

      // Step 2: Find option1 values where all items have meta_hide === true
      const allHiddenOptions = Object.keys(groupedByOption1).filter(
        (option1) => {
          return groupedByOption1[option1].every(
            (item) => item.meta_hide === true
          );
        }
      );
      if(allHiddenOptions.length>0){
        // console.log('allHiddenOptions',allHiddenOptions)
        var hiddenEle = $( `.variant-input[data-value="${allHiddenOptions[0]}"]` );
        if(hiddenEle.length>0){hiddenEle.hide();}
      }
    } else {
      var $atcBtn = $(
        `.pdp_main .product__info-container .product-form__buttons .button:eq(0)`
      );

      // console.log("key", key, "selectorIndex", selectorIndex, hiddenVars);
      // $(`.swatch[data-option-index="${selectorIndex}"] .swatch-element.available`).show();
      if (hiddenVars.length > 0) {
        hiddenVars.forEach((h) => {
          var value = h[`option2`];
          // console.log('value',value,'selectorIndex',selectorIndex);
          var hiddenEle = $(
            `.variant-input[data-index-original="option${selectorIndex}"][data-value="${value}"]`
          );
          // console.log("hiddenEle", hiddenEle);
          if (hiddenEle.length > 0) {
            hiddenEle.addClass('custom-disabled');            
          }
        });
      }
      // console.log('hiddenSingleVar',hiddenSingleVar)
      setTimeout(()=>{
        if(hiddenSingleVar.length>0){
        $atcBtn.find('span.atc-text-custom').text('Unavailable').removeClass('hide');
        $atcBtn.find('span.atc-text').addClass('hide');
        $atcBtn.addClass('disabled').attr('disabled','disabled');
      }
      else{
        $atcBtn.find('span:not(.custom-js-price)').text('Add to cart');
        $atcBtn.find('span.atc-text-custom').text('Add to cart').addClass('hide');
        $atcBtn.find('span.atc-text').removeClass('hide');
        $atcBtn.removeClass('disabled').removeAttr('disabled');
      }
      },50)
    }
  }


  initializeTooltips() {
    const sepTitles = document.querySelectorAll("[data-tooltip]");

    sepTitles.forEach((sepTitle) => {
      var content = sepTitle.getAttribute("data-tooltip");
      // console.log('content',content)
      tippy(sepTitle, {
        content: content,
        allowHTML: true,
        arrow: true,
      });
    });
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select, fieldset"),
      (element) => {
        if (element.tagName === "SELECT") {
          return element.value;
        }
        if (element.tagName === "FIELDSET") {
          return Array.from(element.querySelectorAll("input")).find(
            (radio) => radio.checked
          )?.value;
        }
      }
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === "SELECT" && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(
        `[data-selected-dropdown-swatch="${name}"] > .swatch`
      );
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          swatchValue
        );
        selectedDropdownSwatchValue.classList.remove("swatch--unavailable");
      } else {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          "unset"
        );
        selectedDropdownSwatchValue.classList.add("swatch--unavailable");
      }
    } else if (tagName === "INPUT" && target.type === "radio") {
      const selectedSwatchValue = this.querySelector(
        `[data-selected-swatch-value="${name}"]`
      );
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    console.log("updateVariantInput::",productForms)
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }
  updateVariantStatuses() {
    // Parse the variants from the embedded JSON
    this.variantData = JSON.parse(
      this.querySelector('[type="application/json"]').textContent
    );

    const inputWrappers = [...this.querySelectorAll(".product-form__input")];

    // Add Metafield Data in the Actual Variant Array
    this.variantData.forEach((variant) => {
      const productVariant = productVariantData.find(
        (item) => item.id === variant.id
      );
      variant.meta_hide = productVariant ? productVariant.meta_hide : false;
      variant.sold_out = productVariant ? productVariant.sold_out : false;
    });

    // console.log("productVariantData::", productVariantData, this.variantData)

    inputWrappers.forEach((option, index) => {
      const selectedOption = option.querySelector(":checked");
      if (!selectedOption) return;

      const selectedValue = selectedOption.value;
      const selectedOptionVariants = this.variantData.filter((variant) => {
        // console.log("variant:::",variant[`option${index + 1}`],selectedValue)
        return variant[`option${index + 1}`] === selectedValue;
      });

      // console.log("selectedOptionVariants:",selectedOptionVariants,this.variantData,option)
      inputWrappers.forEach((wrapper, idx) => {
        if (idx === index) return;

        const optionInputs = [...wrapper.querySelectorAll('input[type="radio"], option'),];
        const availableOptionValues = selectedOptionVariants
          .filter((variant) => variant.available)
          .map((variant) => variant[`option${idx + 1}`]);

        this.setInputAvailability(optionInputs, availableOptionValues, idx);
      });
    });
  }
  setInputAvailability(elementList, availableValuesList, optionIndex) {
    // console.log("setInputAvailability::",elementList, availableValuesList, optionIndex)
    elementList.forEach((element) => {
      const value = element.getAttribute("value");
      const parentDiv = element.closest(".variant-input");

      // console.log("parentDiv::",parentDiv,value)
      
      if (!parentDiv) return;
      
      // Extract variant matching current element value
      const variant = productVariantData.find((variant) => variant.option1 === value || variant.option2 === value && variant.meta_hide === true);
      // Extract data attributes from the parent div
      const metaHide = parentDiv.getAttribute("data-hide-variant") === "true";
      const soldOut = parentDiv.getAttribute("data-sold-out") === "true";
      let isAvailable = availableValuesList.includes(value);
      if(window.theme.isRetailProduct){
        isAvailable = true;
      }
      
      parentDiv.classList.remove("unavail");
      parentDiv.classList.remove("switchable-variant"); // NEW: reset cross-size switch flag each run

      // Apply classes based on conditions
      if (metaHide) {
        parentDiv.classList.add("hide");
        parentDiv.classList.remove("disabled");
        return;
      }
      if (soldOut) {
        if (!isAvailable) {
          parentDiv.classList.add("disabled");
          parentDiv.classList.remove("hide");
          return;
        }
      }
      if (!isAvailable) {
        if (!soldOut && metaHide) {
          parentDiv.classList.add("hide");
          parentDiv.classList.remove("disabled");
          return;
          if (variant) {
            parentDiv.classList.add("hide");
            parentDiv.classList.remove("disabled");
          }
        }
        if (!metaHide) {
          // console.log('3','disaled',metaHide,parentDiv)
          parentDiv.classList.add("disabled");
          parentDiv.classList.add("unavail");
          // NEW: if this flavor (option2) is available under a DIFFERENT size (option1),
          // mark it switchable so a click can auto-jump to that size.
          if (optionIndex === 1) {
            const availableInOtherSize = productVariantData.some(
              (v) => v.option2 === value && v.available === true && v.meta_hide !== true
            );
            if (availableInOtherSize) {
              parentDiv.classList.add("switchable-variant");
            }
          }
        }
      } else {
        parentDiv.classList.remove("disabled");
        parentDiv.classList.remove("hide");
      }
    });
  }

  // NEW: when an UNAVAILABLE flavor (option2) is clicked, but it IS available under a
  // different size (option1), auto-switch the size and select that variant.
  // If the flavor is available in the current size -> do nothing (normal flow handles it).
  // If the flavor is available nowhere -> do nothing (existing "Unavailable" behavior stays).
  onCrossSizeFlavorClick(event) {
    const clickedInput = event.target.closest(".variant-input");
    if (!clickedInput) return;

    // Only act on clicks inside the flavor (2nd option) group
    if (!clickedInput.closest(".option-size-2")) return;

    const flavorValue = clickedInput.getAttribute("data-value");
    if (!flavorValue) return;

    const checkedSizeInput = this.querySelector(".option-size-1 input:checked");
    const currentSize = checkedSizeInput ? checkedSizeInput.value : null;

    // Already available under current size? -> let the normal flow handle it.
    const availableHere = productVariantData.some(
      (v) =>
        v.option1 === currentSize &&
        v.option2 === flavorValue &&
        v.available === true &&
        v.meta_hide !== true
    );
    if (availableHere) return;

    // Find a DIFFERENT size where this flavor is available (and not metafield-hidden).
    const target = productVariantData.find(
      (v) =>
        v.option2 === flavorValue &&
        v.option1 !== currentSize &&
        v.available === true &&
        v.meta_hide !== true
    );

    // Not available anywhere -> keep existing "Unavailable" behavior untouched.
    if (!target) return;

    // Stop the native radio from locking into an invalid (size + unavailable flavor) state.
    event.preventDefault();
    event.stopPropagation();

    const sizeInput = this._findOptionInput(".option-size-1", target.option1);
    const flavorInput = this._findOptionInput(".option-size-2", flavorValue);

    if (sizeInput) sizeInput.checked = true;   // auto-unchecks other sizes (same radio group)
    if (flavorInput) flavorInput.checked = true; // auto-unchecks other flavors

    // Fire ONE change so the existing onVariantChange flow resolves the correct variant.
    const trigger = flavorInput || sizeInput;
    if (trigger) {
      trigger.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  // NEW helper: find a radio input by its option value inside a given option container.
  _findOptionInput(containerSelector, value) {
    const inputs = this.querySelectorAll(
      containerSelector + ' .variant-input input[type="radio"]'
    );
    for (const input of inputs) {
      if (input.value === value) return input;
    }
    return null;
  }

  handleOptionChange(event) {
    this.updateVariantStatuses();

    const selectedOption = event.target;
    if (selectedOption && !selectedOption.classList.contains("disabled")) {
      // Trigger update when available options change
      this.updateVariantStatuses();
    }
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    // console.log('sectionId',sectionId)
    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (!this.currentVariant) return;
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");

        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut
        );

        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        const volumePricingSource = html.getElementById(
          `Volume-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const pricePerItemDestination = document.getElementById(
          `Price-Per-Item-${this.dataset.section}`
        );
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const volumePricingDestination = document.getElementById(
          `Volume-${this.dataset.section}`
        );
        const qtyRules = document.getElementById(
          `Quantity-Rules-${this.dataset.section}`
        );
        const volumeNote = document.getElementById(
          `Volume-Note-${this.dataset.section}`
        );

        if (volumeNote) volumeNote.classList.remove("hidden");
        if (volumePricingDestination)
          volumePricingDestination.classList.remove("hidden");
        if (qtyRules) qtyRules.classList.remove("hidden");

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "hidden",
            skuSource.classList.contains("hidden")
          );
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle(
            "hidden",
            pricePerItemSource.classList.contains("hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "hidden",
            inventorySource.innerText === ""
          );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    // const addButton = productForm.querySelector('[name="add"]');
    // const addButtonText = productForm.querySelector('[name="add"] > span');
    // if (!addButton) return;
    // // console.log('disable',disable)
    // if (disable) {
    //   addButton.setAttribute("disabled", "disabled");
    //   // addButton.style.display = 'none';
    //   if (text) addButtonText.textContent = text;
    // } else {
    //   addButton.removeAttribute("disabled");
    //    // addButton.style.display = 'block';
    //   addButtonText.textContent = window.variantStrings.addToCart;
    // }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(
      `Price-Per-Item-${this.dataset.section}`
    );
    const volumeNote = document.getElementById(
      `Volume-Note-${this.dataset.section}`
    );
    const volumeTable = document.getElementById(
      `Volume-${this.dataset.section}`
    );
    const qtyRules = document.getElementById(
      `Quantity-Rules-${this.dataset.section}`
    );
    addButton.removeAttribute("disabled");

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    addButton.setAttribute("disabled", "disabled");
    if (price) price.classList.add("hidden");
    if (inventory) inventory.classList.add("hidden");
    if (sku) sku.classList.add("hidden");
    if (pricePerItem) pricePerItem.classList.add("hidden");
    if (volumeNote) volumeNote.classList.add("hidden");
    if (volumeTable) volumeTable.classList.add("hidden");
    if (qtyRules) qtyRules.classList.add("hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
  getProductData() {
    this.ProductData =
      this.ProductData ||
      JSON.parse(this.querySelector("#productJson").textContent);
    return this.ProductData;
  }
}
customElements.define("variant-selects", VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

$(document).ready(function () {
  $("body").on("mouseenter", ".flavour_tabs_main .title_wrp", function () {
    var id = $(this).attr("id");

    $(`.flavour_tabs_main .title_wrp`).removeClass("active");
    $(this).addClass("active");

    $(`.flavour_tabs_main .flavour_center .img_wrp`).removeClass("active");
    $(`.flavour_tabs_main .flavour_center .img_wrp[data-id=${id}]`).addClass(
      "active"
    );

    $(`.flavour_tabs_main .desc_lists .desc_wrp`).removeClass("active");
    $(`.flavour_tabs_main .desc_lists .desc_wrp[data-id=${id}]`).addClass(
      "active"
    );
  });

  if (window.innerWidth <= 768) {
    // var swiper = new Swiper(".ic_lists", {
    //   loop: true,
    //   centeredSlides: true,
    //   spaceBetween: 30,
    //   // slidesPerView: 'auto',
    //   slidesPerView: 4,
    //   pagination: {
    //     el: ".swiper-pagination",
    //     clickable: true,
    //   },
    //   navigation: {
    //     nextEl: ".swiper-button-next",
    //     prevEl: ".swiper-button-prev",
    //   },
    // });
  }

  if (document.querySelector(".swiper-container.slider-main")) {
    var swiper = new Swiper(".swiper-container.slider-main", {
      loop: true,
      spaceBetween: 30,
      slidesPerView: 1,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
});

function customOption() {
  const parent = document.querySelector(".color_select");
  if (parent) {
    const select = parent.querySelector("select");

    // Remove existing custom button and dropdown if they exist
    const existingButton = parent.parentNode.querySelector(
      ".custom-dropdown-button"
    );
    const existingDropdown =
      parent.parentNode.querySelector(".custom-dropdown");
    if (existingButton) {
      existingButton.remove();
    }
    if (existingDropdown) {
      existingDropdown.remove();
    }

    // Create the custom dropdown button
    const dropdownButton = document.createElement("button");
    dropdownButton.className = "custom-dropdown-button";

    // Function to update button text
    function updateButton() {
      const selectedOption = select.options[select.selectedIndex];
      const selectedValue = selectedOption.value;
      const swatchImage = selectedOption.getAttribute(
        "data-option-swatch-value"
      );

      // Update button's inner HTML to reflect the selected option text
      dropdownButton.innerHTML = `
        <img src="${swatchImage}" alt="${selectedOption.text}" style="width: 20px; height: 20px; vertical-align: middle; margin-right: 8px;"> ${selectedOption.text}
        <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6" style="width: 10px; height: 6px; vertical-align: middle; margin-left: 8px;">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
        </svg>`;
    }

    // Insert the button before the select
    parent.parentNode.insertBefore(dropdownButton, parent);
    select.style.display = "none"; // Hide the original select

    // Create the custom dropdown list
    const customDropdown = document.createElement("ul");
    customDropdown.className = "custom-dropdown";
    customDropdown.setAttribute("data-option-name", "Color");

    // Loop through the options to create the list items
    Array.from(select.options).forEach((option) => {
      const li = document.createElement("li");
      li.className = "custom-dropdown__item";
      li.setAttribute("data-value", option.value);

      // Get swatch image URL or fallback
      const swatchValue = option.getAttribute("data-option-swatch-value");
      const imgSrc = swatchValue ? swatchValue : "//default-image-url.png"; // Fallback image if no swatch

      // Use the exact text of the option for the list item
      const optionText = option.text;

      // Create the inner HTML for the list item
      li.innerHTML = `
        <img src="${imgSrc}" alt="${optionText}">
        <span>${optionText}</span>`;

      // Add event listener for selecting the option
      li.addEventListener("click", function () {
        // Update the original select value
        select.value = option.value;

        // Update the button content to reflect the selected value
        updateButton();

        // Close the dropdown
        customDropdown.classList.remove("open");

        // Trigger change event on the select to update the variant
        select.dispatchEvent(new Event("change", { bubbles: true }));
      });

      // Append the list item
      customDropdown.appendChild(li);
    });

    // Set the initial state of the dropdown and button
    updateButton();

    // Insert the custom dropdown after the button
    dropdownButton.parentNode.insertBefore(
      customDropdown,
      dropdownButton.nextSibling
    );

    // Add click event to the dropdown button to toggle the dropdown visibility
    dropdownButton.addEventListener("click", function (event) {
      event.stopPropagation(); // Prevent event from bubbling up
      customDropdown.classList.toggle("open"); // Toggle the 'open' class
    });

    // Close the dropdown when clicking outside of it
    document.addEventListener("click", function (event) {
      if (
        !dropdownButton.contains(event.target) &&
        !customDropdown.contains(event.target)
      ) {
        customDropdown.classList.remove("open"); // Hide the dropdown
      }
    });
  }
}
document.addEventListener("DOMContentLoaded", function () {
  // Get the select element
  customOption();

  // PDP Benefit Slider
  if (window.innerWidth < 990) {
    if (
      $(
        "body.product-rtd-pdp .product__info-wrapper > .mobile-benefit > .main-content.mobile-content .benefits-main"
      ).length > 0
    ) {
      $(
        "body.product-rtd-pdp .product__info-wrapper > .mobile-benefit > .main-content.mobile-content .benefits-main"
      ).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        adaptiveHeight: true,
      });
    }
  }
});

// philanthropy_banner
document.addEventListener("DOMContentLoaded", function () {
  if (window.theme.back_btn_text) {
    var backToAccountMember = `<div class="back-to-account-wrapper membership-back-wrapper">
       <a href="${window.theme.back_btn_link}" class="back-to-account">
         <svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg>
         <span>${window.theme.back_btn_text}</span>
       </a>
     </div>`;

    if (window.theme.shop_btn_text) {
      var backToAccountSubscription = `<div class="back-to-account-wrapper subscription-back-wrapper">
         <a href="${window.theme.back_btn_link}" class="back-to-account">
           <svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg>
           <span>${window.theme.back_btn_text}</span>
         </a>
         <span>|</span>
         <a href="${window.theme.shop_btn_link}" class="back-to-account shop-btn-wrapper">
           <span>${window.theme.shop_btn_text}</span>
         </a>
       </div>`;
    }
  }

  // Set up the MutationObserver
  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      if (mutation.type === "childList") {
        // Check if the target element was added
        $(mutation.addedNodes).each(function () {
          if ($(this).is(".loop-grid-container")) {
            if (backToAccountSubscription && $('.subscription-back-wrapper').length == 0) {
              $(this).parent().prepend(backToAccountSubscription);
            }
          }
          if($('.loop-grid-item').length){
            $('.subscription-back-wrapper').remove();
            setTimeout(()=>{
              if($('.loop-grid-item div.loop-btn-nav').length && $('.back-to-subs').length == 0){
               $('.loop-grid-item div.loop-btn-nav').append(`<span class="back-to-subs">Back to subscriptions</span>`)
              }              
            },100)
          }
          if ($(this).is(".inveterate__credits_table_header")) {
            if (
              $(".inveterate__member__inner.inveterate__visible").length > 0
            ) {
              if (backToAccountMember) {
                $(".inveterate__member__inner.inveterate__visible").prepend(
                  backToAccountMember
                );
              }
            }
          }
        });
      }
    });
  });

  // Start observing the body for child node additions
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  setTimeout(() =>{
    let count = 0;
    const counterElement = $(".rich-text_content");
    if (counterElement.length) {
      const targetValue = parseInt(
        counterElement.data("count").replace(/[^0-9]/g, ""),
        10
      );
  
      const interval = setInterval(function () {
        count += 4578;
        counterElement.text("$" + count.toLocaleString());
        counterElement.attr("data-name", "$" + count.toLocaleString());
        counterElement.attr("data-count", "$" + count.toLocaleString());
  
        if (count >= targetValue) {
          counterElement.text("$" + targetValue.toLocaleString());
          counterElement.attr("data-name", "$" + targetValue.toLocaleString());
          counterElement.attr("data-count", "$" + targetValue.toLocaleString());
          clearInterval(interval);
        }
      }, 50);
    }
  },500)
});

// Discount Based on Quantity
document.addEventListener("DOMContentLoaded", function () {
  const quantityInputs = document.querySelectorAll( '.quantity-selector-buttons input[name="quantity"]' );

  function updatePrice(selectedInput) {
    let basePrice = Number(selectedInput.getAttribute("data-price"));
    let productId = Number(selectedInput.getAttribute("data-productid"));
    let variantId = Number(selectedInput.getAttribute("data-id"));
    let quantityDiscount = Number(selectedInput.getAttribute("data-discount"));

    let loopData = window?.loopProps?.[productId];
    let sellingPlanId = loopData?.sellingPlanId;

    let wrapperForm = selectedInput.closest("form");

    let finalSubscriptionPrice = basePrice;
    let finalOneTimePrice = basePrice;

    // -------------------------
    // 1. ONE-TIME DISCOUNT
    // -------------------------
    if (quantityDiscount > 0) {
      finalOneTimePrice = basePrice - (basePrice * quantityDiscount) / 100;
    }

    // -------------------------
    // 2. SUBSCRIPTION LOGIC
    // -------------------------    
    if (sellingPlanId && loopData?.sellingPlanDefination) {
      const sellingPlan = loopData.sellingPlanDefination;

      const discount = sellingPlan.price_adjustments?.[0]?.value || 0;
      const discountType = sellingPlan.price_adjustments?.[0]?.value_type;

      // quantity discount first (if any)
      if (quantityDiscount > 0) {
        finalSubscriptionPrice = basePrice - (basePrice * quantityDiscount) / 100;
      }

      // selling plan discount
      if (discountType === "percentage") {
        finalSubscriptionPrice = finalSubscriptionPrice - (finalSubscriptionPrice * discount) / 100;
      }
    }else{
      const mainloopBlock = document.querySelector(`#loop-product-variant-${variantId}`)
      const discount = Number(mainloopBlock.querySelectorAll('.loop-full-width.loop-selling-plan-selector option:checked')[0].getAttribute('data-discount'));
      
      finalSubscriptionPrice = basePrice - (basePrice * quantityDiscount) / 100;
      finalSubscriptionPrice = finalSubscriptionPrice - (finalSubscriptionPrice * discount) / 100;
    }

    // -------------------------
    // 3. FORMAT + RENDER
    // -------------------------
    const formattedOneTime = finalOneTimePrice.toFixed(2);
    const formattedSub = finalSubscriptionPrice.toFixed(2);

    const ATCButton = wrapperForm.querySelector( ".product-form__buttons button .custom-js-price.price" );
    if (ATCButton) {
      if (sellingPlanId) {
        // subscription UI
        ATCButton.innerHTML = `<span>-</span> <strike>${Shopify.formatMoney(formattedOneTime)}</strike> ${Shopify.formatMoney(formattedSub)} `;
      } else {
        // one-time UI
        ATCButton.innerHTML = `<span>-</span> ${Shopify.formatMoney(formattedOneTime)}`;
      }
    }

    // optional UI updates inside loop subscription block
    const subscriptionPriceElement = wrapperForm.querySelector(`#loop-product-variant-${variantId} .loop-selling-discount`);
    if (subscriptionPriceElement) {
      subscriptionPriceElement.innerHTML = Shopify.formatMoney(formattedSub);
    }

    const oneTimePriceElement = wrapperForm.querySelector( ".loop-one-time-purchase-option-price-container .loop-discount-price" );
    if (oneTimePriceElement) {
      oneTimePriceElement.innerHTML = Shopify.formatMoney(formattedOneTime);
    }
  }

  // quantityInputs.forEach((input) => {
  //   input.addEventListener("change", function () {
  //     if (this.checked) {
  //       updatePrice(this);
  //     }
  //   });
  // });
  quantityInputs.forEach((input) => {
    input.addEventListener("change", function () {
      const wrapper = this.closest(".quantity-selector-wrapper");
      const heading = wrapper?.querySelector(".quantity-selector-info--heading");

      if (this.checked) {
        updatePrice(this);

        if (this.value === "1") {
          heading?.classList.remove("active");
        } else {
          heading?.classList.add("active");
        }
      } else {
        // optional: unchecked thay tyare active remove karvu hoy to
        heading?.classList.remove("active");
      }
    });
  });


  // Thumbnail images
  const thumbnails = document.querySelectorAll(".feature-thumbnail");
  const wrapper3D = document.querySelector(".product-3d-imgs-wrapper");
  const mainImageWrapper = document.querySelector(".product-main-image");
  if(!mainImageWrapper) return
  const mainImage = mainImageWrapper.querySelector("img");

  thumbnails.forEach((thumb) => {
    thumb.addEventListener("click", function () {
      const type = this.dataset.type;

      // Remove active class from all thumbnails
      thumbnails.forEach((t) => t.classList.remove("active"));

      // Add active class to clicked thumbnail
      this.classList.add("active");

      if (type === "3d") {
        wrapper3D.style.display = "block";
        mainImageWrapper.style.display = "none";
      } else {
        mainImage.src = this.src;
        wrapper3D.style.display = "none";
        mainImageWrapper.style.display = "block";
      }
    });
  });
});

document.addEventListener("rebuy.change", function (event) {
  console.log("rebuy.change event", event.detail);
});

// Rebuy Ready EVENT
document.addEventListener("rebuy:smartcart.ready", (event) => {
  let cartItems = event.detail.smartcart.cart.items;
  cartItems.forEach((item) => {
    var { product, id, quantity } = item;
    var Pro = productData.find((p) => p.product_id === product.id);

    if (Pro) {
      var Var = Pro.variants.find((v) => v.variant_id === id);
      if (Var) {
        var cartItemElement = Array.from(document.querySelectorAll(".rebuy-cart__flyout-item-variant-title"))
          .find((el) => el.textContent.trim() === Var?.variant_title?.trim())?.closest(".rebuy-cart__flyout-item");

        cartItemElement?.classList.toggle("limit-over",Var?.variant_metafield && quantity >= Var.variant_metafield);

        var qtyWarningInput = document.querySelector(".product-add-to-cart-error");
        if (Var?.variant_metafield && quantity >= Var.variant_metafield && cartItemElement != null && qtyWarningInput) {
          const clonedElement = qtyWarningInput.cloneNode(true);
          var targetElement = cartItemElement.querySelector(".rebuy-cart__flyout-item-info");
          var checkElement = cartItemElement.querySelector(".product-add-to-cart-error");
          if (!checkElement) {
            targetElement.appendChild(clonedElement);
            document.body.classList.add("no-action-atc-btn");
          }
        } else {
          if (cartItemElement != null) {
            var targetElement = cartItemElement.querySelector(".product-add-to-cart-error");
            if (targetElement) {
              targetElement.remove();
              document.body.classList.remove("no-action-atc-btn");
            }
          }
        }

        // For Pricing Subscription
        subscriptionPricing(product, cartItemElement);
      }
    }
  });

  if (event.detail.smartcart.cart.item_count == 0) {
    var shopBtn = document.querySelector(".rebuy-cart__flyout-empty-cart a");
    if (shopBtn) {
      shopBtn.removeAttribute("target");
    }
  }


  /* Name - Date - Ticket # - Disables ATC button and changes text to "Sold Out" if any bundle product is OOS */
  // setTimeout(() => {
  //   const bundleButton = document.querySelector(`#rebuy-widget-185841 .rebuy-button`)
  //   widget.data.products.forEach(product => {
  //     if (product.selected_variant.inventory_quantity < 1) {
  //       bundleButton.disabled = true
  //       bundleButton.textContent = bundleButton.textContent.replace('Add to Cart', 'Sold Out')
  //     }
  //   })
  // })
});

function subscriptionPricing(product, cartItemElement) {
  if(product.selling_plan_groups.length>0){
    var sellingPlans = product.selling_plan_groups[0].selling_plans;
      let highestValue = null;
    
      sellingPlans.forEach((plan) => {
        plan.price_adjustments.forEach((adjustment) => {
          const value = parseFloat(adjustment.value);
          if (highestValue === null || value > highestValue) {
            highestValue = value;
          }
        });
      });
    
      // console.log("highestValue:",highestValue,cartItemElement);
    
      var subscriptionButton = cartItemElement.querySelector(
        ".rebuy-cart__flyout-item-subscription .rebuy-button span"
      );
      // console.log("cartItemElement::",cartItemElement,subscriptionButton)
      if (subscriptionButton) {
        let textContent = subscriptionButton.textContent.trim();
        if (textContent.endsWith("%")) {
          subscriptionButton.textContent =
            textContent.replace(/[\d%]+$/, "") +
            Shopify.formatMoney(highestValue * 100);
        }
      }
  } 
}

function rebuyItemIncreaseDecrease(event, plus) {
  var { product, id, quantity } = event.detail.item;
  var ItemCount = plus ? quantity + 1 : quantity - 1;
  var Pro = productData.find((p) => p.product_id === product.id);
  var Var = Pro?.variants.find((v) => v.variant_id === id);

  var cartItemElement = Array.from(document.querySelectorAll(".rebuy-cart__flyout-item-variant-title"))
    .find((el) => el.textContent.trim() === Var?.variant_title?.trim())
    ?.closest(".rebuy-cart__flyout-item");

  // console.log("cartItemElement::",cartItemElement,event)
  cartItemElement?.classList.toggle("limit-over",Var?.variant_metafield && ItemCount >= Var.variant_metafield);

  // Change ATC button Wrapper JS
  var quantityInput = document.querySelector(".pdp_main .product__info-container .product-form__quantity .quantity__input");
  var remainingCount = Var.variant_metafield - ItemCount;
  if (quantityInput && remainingCount >= 0) {
    quantityInput.dataset.cartQuantity = ItemCount;
    quantityInput.max = remainingCount;
    if (remainingCount == 0) {
      quantityInput.value = remainingCount;
      quantityInput.min = remainingCount;
    } else {
      quantityInput.min = 1;
      quantityInput.value = 1;
    }
  }

  // Warning Message
  var qtyWarningInput = document.querySelector(".product-add-to-cart-error");
  if (Var?.variant_metafield && ItemCount >= Var.variant_metafield && cartItemElement != null) {
    var variant_title = Var.variant_title.split("/")[1];
    var qty_limit = theme.qty_limit_msg;
    qty_limit = qty_limit
      .replaceAll("XX", Var.variant_metafield)
      .replaceAll("YY", variant_title);
    if (qtyWarningInput) {
      qtyWarningInput.innerHTML = qty_limit;
    }
    const clonedElement = qtyWarningInput.cloneNode(true);
    var targetElement = cartItemElement.querySelector(".rebuy-cart__flyout-item-info");
    var checkElement = cartItemElement.querySelector(".product-add-to-cart-error");
    if (!checkElement) {
      targetElement.appendChild(clonedElement);
      document.body.classList.add("no-action-atc-btn");
    }
  } else {
    if (qtyWarningInput) {
      qtyWarningInput.innerHTML = "";
    }
    if (cartItemElement != null) {
      var targetElement = cartItemElement.querySelector(".product-add-to-cart-error");
      if (targetElement) {
        targetElement.remove();
        document.body.classList.remove("no-action-atc-btn");
      }
    }
  }
}

// Rebuy Increase EVENT
document.addEventListener("rebuy:smartcart.line-item-increase", (event) => {
  rebuyItemIncreaseDecrease(event, true);
    setTimeout(() => {
    updateCartCount();
  }, 500);
});

// Rebuy Decrease EVENT
document.addEventListener("rebuy:smartcart.line-item-decrease", (event) => {

  console.log("smartcart.line-item-decrease::",event)
  rebuyItemIncreaseDecrease(event, false);
   setTimeout(() => {
    updateCartCount();
  }, 500);
});

// Rebuy Add EVENT
document.addEventListener("rebuy:cart.add", (event) => {
  setTimeout(() => {
    console.log("ADD");
    var addItem = event.detail.item;
    var { id, quantity } = addItem;
    var Pro = productData.find((p) => p.product_id === addItem.product_id);
    var Var = Pro?.variants.find((v) => v.variant_id === id);
    var cartItemElement = Array.from(
      document.querySelectorAll(".rebuy-cart__flyout-item-variant-title")
    )
      .find((el) => el.textContent.trim() === Var?.variant_title?.trim())
      ?.closest(".rebuy-cart__flyout-item");

    cartItemElement?.classList.toggle(
      "limit-over",
      Var?.variant_metafield && quantity >= Var.variant_metafield
    );

    if (
      Var?.variant_metafield &&
      quantity >= Var.variant_metafield &&
      cartItemElement != null
    ) {
      var variant_title = Var.variant_title.split("/")[1];
      var qty_limit = theme.qty_limit_msg;
      qty_limit = qty_limit
        .replaceAll("XX", Var.variant_metafield)
        .replaceAll("YY", variant_title);
      var warningHTML = `<p class="error" style="color:#ff5857;margin: 0;line-height: 1.2;">${qty_limit}</p>`;
      var targetElement = cartItemElement.querySelector(
        ".rebuy-cart__flyout-item-info"
      );
      var tempDiv = document.createElement("div");
      tempDiv.classList.add("product-add-to-cart-error");
      tempDiv.innerHTML = warningHTML;

      var checkElement = cartItemElement.querySelector(
        ".product-add-to-cart-error"
      );
      if (checkElement == null) {
        targetElement.appendChild(tempDiv);
      }
      document.body.classList.add("no-action-atc-btn");
    } else {
      if (cartItemElement != null) {
        var targetElement = cartItemElement.querySelector(
          ".product-add-to-cart-error"
        );
        if (targetElement) {
          targetElement.remove();
          document.body.classList.remove("no-action-atc-btn");
        }
      }
    }

    // For Pricing Subscription
    var subscriptionCartItems = window.Rebuy.SmartCart.cart.items;
    subscriptionCartItems.forEach((item) => {
      var { product, id, quantity } = item;
      var Pro = productData.find((p) => p.product_id === product.id);

      if (Pro) {
        var Var = Pro.variants.find((v) => v.variant_id === id);
        if (Var) {
          var cartItemElement = Array.from(
            document.querySelectorAll(".rebuy-cart__flyout-item-variant-title")
          )
            .find((el) => el.textContent.trim() === Var?.variant_title?.trim())
            ?.closest(".rebuy-cart__flyout-item");

          // For Pricing Subscription
          subscriptionPricing(product, cartItemElement);
        }
      }
    });
  }, 2000);
});

// Rebuy Remove EVENT
document.addEventListener("rebuy:smartcart.line-item-removed", (event) => {
  console.log("event.detail::",event.detail)
  const item = event.detail.item;
  var { id, quantity } = item;
  var Pro = productData.find((p) => p.product_id === item.product_id);
  var Var = Pro?.variants.find((v) => v.variant_id === id);
  var cartItemElement = Array.from(document.querySelectorAll(".rebuy-cart__flyout-item-variant-title")).find(
    (el) => el.textContent.trim() === Var?.variant_title?.trim()
  )?.closest(".rebuy-cart__flyout-item");

  if (Var.variant_metafield == quantity) {
    if ($(".pdp_main .product__info-container .product-form__buttons button.button")) {
      $(".pdp_main .product__info-container .product-form__buttons button.button").trigger("click");
    }
    document.body.classList.remove("no-action-atc-btn");
  }
    updateCartCount();
});

$(document).ready(function () {
  $("body").on("click", ".recipe_atc_btn", function (e) {
    e.preventDefault();
    var $this = $(this),
      id = $this.data("variant-id");
    let data = {
      id: id,
      quantity: 1,
    };
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .catch(console.error);
  });

  // Get the URL parameters
  const urlParams = new URLSearchParams(window.location.search);
  const filterTag = urlParams.get("filter");

  if (filterTag) {
    const $filterButton = $(".filter-button[data-tag='" + filterTag + "']");

    setTimeout(() => {
      if ($filterButton.length) {
        $filterButton.trigger("click");
      }
    });
  }

  // Tabbing script for the article filter in the Blog Page
  const $buttons = $(".filter-button");
  const $articles = $(".article-item");
  var oldText = $(".section-blog-banner .banner_heading.custom-heading").text();
  $buttons.on("click", function () {
    const tag = $(this).data("tag");

    // Update active button
    $buttons.removeClass("active");
    $(this).addClass("active");

    // Reset all articles
    if (tag === "all") {
      $articles.removeClass("filtered").addClass("hide");
      $articles.slice(0, 9).removeClass("hide");
      $(".view-more-btn").removeClass("hide");
      $("body").removeClass("filter-active");

      // Update URL to remove filter
      history.pushState(null, "", window.location.pathname);
      $(".section-blog-banner .banner_heading.custom-heading .heading").text(
        oldText
      );
    } else {
      $("body").addClass("filter-active");
      // Filter articles
      const filteredArticles = $articles.filter(function () {
        const articleTags = $(this).data("tags").split(",");
        return articleTags.includes(tag);
      });

      // Show the first 9 filtered articles
      $articles.addClass("hide").removeClass("filtered");
      filteredArticles.slice(0, 9).removeClass("hide").addClass("filtered");

      if (filteredArticles.length > 9) {
        $(".view-more-btn").removeClass("hide");
      } else {
        $(".view-more-btn").addClass("hide");
      }

      // Update URL with the selected filter
      const newUrl = `?filter=${tag}`;
      history.pushState(null, "", newUrl);
      $(".section-blog-banner .banner_heading.custom-heading .heading").text(
        tag
      );
    }
  });

  // Click event for the view more button
  $("body").on("click", ".view-more-btn", function (e) {
    e.preventDefault();

    const hasFilterActive = $("body").hasClass("filter-active");

    var hiddenArticles;
    if (hasFilterActive) {
      hiddenArticles = $(".article-item.filtered.hide");
    } else {
      hiddenArticles = $(".blog-articles.articles-list .article-item.hide");
    }

    hiddenArticles.slice(0, 9).removeClass("hide");

    if (hiddenArticles.length <= 9) {
      $(this).addClass("hide");
    }
  });

  // const canvas_img = document.querySelector("#svg-container");
  // const cursor = document.querySelector(".main_imges");
  // canvas_img.addEventListener("mousemove", (e) => {
  //   cursor.style.left = e.clientX + "px";
  //   cursor.style.top = e.clientY + "px";
  //   cursor.classList.add("showw");
  // });
  // canvas_img.addEventListener("mouseleave", (e) => {
  //   cursor.classList.remove("showw");
  // });
  document.querySelectorAll('.can-wrapper').forEach(wrapper => {
    const canvas_img = wrapper.querySelector("#svg-container");
    const cursor = wrapper.querySelector(".main_imges");
    canvas_img.addEventListener("mousemove", (e) => {
      cursor.style.left = e.clientX + "px";
      cursor.style.top = e.clientY + "px";
      cursor.classList.add("showw");
    });
    canvas_img.addEventListener("mouseleave", (e) => {
      cursor.classList.remove("showw");
    });
  });

});

function updateCartCount() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {

      // Dawn/cart bubble selector
      const cartBubble = document.querySelector(
        "#cart-icon-bubble .cart-count-bubble span"
      );

      // Custom selector fallback
      const customBubble = document.querySelector(
        ".cart-count-bubble span"
      );

      if (cartBubble) {
        cartBubble.textContent = cart.item_count;
      }

      if (customBubble) {
        customBubble.textContent = cart.item_count;
      }

      // Hide bubble when cart empty
      if (cart.item_count === 0) {
        document.body.classList.add("cart-empty");
      } else {
        document.body.classList.remove("cart-empty");
      }
    })
    .catch((err) => console.log(err));
}